import Vue from 'vue'
import axios from 'axios'

const defaultSettings = {
  save: false, // save to store
  limit: 5, // number of items per request
  offset: 0, // db query offset
}

export default {
  namespaced: true,  // it's a module

  state: {
    items: {},
    total: {}
  },

  getters: {
    items: (state) => (model) => {
      return state.items[model]
    },
    total: (state) => (model) => {
      return state.total[model]
    }
  },

  mutations: {
    setItems(state, {
      model,
      items,
      total
    }) {
      Vue.set(state.items, model, items)
      Vue.set(state.total, model, total)
    }
  },

  actions: {
    async getItem ({ }, {
      /** @number */
      id,
      /** @string */
      model
    }) {
      try {
        const { data } = await axios.get(`/${model}/${id}`)
        return Promise.resolve(data)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getItems({ commit }, {
      /** @string */
      model,
      /** @object {
       *  limit: number | boolean
       *  offset: number
       *  sort: string <model.name>.<model.column>+<mode:ASC|DESC>[,<model.name>.<model.column>+<mode>[,...]]
       *  search: string
       *  searchMode: string AND|OR
       *  search: object {
       *    query: string <model.name>.<model.column>+<keyword>[,<model.name>.<model.column>+<keyword>[,...]]
       *    mode: stirng AND|OR
       *  }
       *  filter: string
       *  filterMode: string AND|OR
       *  filter: object {
       *    query: string <model.name>.<model.column>+<value>[,<model.name>.<model.column>+<value>[,...]]
       *    mode: string AND|OR
       *  }
       *  dateFrom: string
       *  dateTo: string
       * }
       */
      params = {},
      save = defaultSettings.save
    }) {

      const queryParams = Object.assign({}, params)

      // db query limit
      if (params.limit !== undefined) {
        if (params.limit) {
          queryParams.limit = params.limit
        }
      }
      // search params
      if (params.search) {
        if ((/string/).test(typeof params.search)) {
          queryParams.search = params.search
        }
        if ((/object/).test(typeof params.search)) {
          queryParams.search = params.search.query
          queryParams.searchMode = params.search.mode || 'AND'
        }
      }
      // record filtering
      if (params.filter) {
        if ((/string/).test(typeof params.filter)) {
          queryParams.filter = params.filter

        } else if (Array.isArray(params.filter)) {
          const filter = params.filter
            .filter(item => (Array.isArray(item.value) && item.value.length) || (!Array.isArray(item.value) && !!item.value))
            .map(item => `filter:${item.name}${item.operator || '='}${[].concat(item.value).join(',')}`)
            .map(item => item.split('='))

          delete queryParams.filter
          Object.assign(queryParams, Object.fromEntries(filter))

        } else if ((/object/).test(typeof params.filter)) {
          queryParams.filter = params.filter.query
          queryParams.filterMode = params.filter.mode || 'AND'
        }
      }

      try {
        const response = await axios.get(`/${model}`, {
          params: queryParams
        })

        const items = response.data
        const total = Number(response.headers['x-total-count'])

        if (save) {
          commit('setItems', {
            model,
            items,
            total
          })
        }

        return Promise.resolve({
          items,
          total
        })
      } catch (error) {
        // @todo handle response: store.handleAxiosResponse
        return Promise.reject(error)
      }
    },

    async downloadFile ({ }, { id }) {
      try {
        const { data, headers } = await axios({
          method: 'GET',
          responseType: 'blob',
          url: '/files/' + id + '/download'
        })

        return Promise.resolve({
          data: data,
          mime: headers['content-type']
        })
      } catch (error) {
        return Promise.resolve(error)
      }
    }
  }
}
